import { Component, Input, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-notes-data',
  templateUrl: './notes-data.component.html',
  styleUrls: ['./notes-data.component.scss']
})
export class NotesDataComponent implements OnInit {


  @Input() timeline;
  @Input() title;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
  ) { }

  ngOnInit(){

    // this.dialogRef.updateSize('40%', 'auto');
  }

}
